import React from 'react';
import './Header.css';
import logo from '../../assets/logo.png';

const Header = () => {
  return (
    <header className="app-header">
      <div className="header-left">
        <img src={logo} alt="Mall Logistics Logo" className="header-logo" />
      </div>
      <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'center'}}>
        <span className='header-title'>Mall Logistics Teslim Süreci</span>
      </div>
    </header>
  );
};

export default Header;
